// extracted by mini-css-extract-plugin
module.exports = {"close":"AJQliZB0","icon":"_37FmOh5O"};